module.exports = __webpack_public_path__ + "static/media/sell_invoice_rent.3ff3bd24.jpg";